import React, {FC} from 'react';

import {ModifyCardGroupsDropdownTypesEnum} from '../../../../../../../../../../src/components/common/dropdowns/cardGroups/modifyCardGroupDropdown';
import {RendererOf} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {ButtonChevron} from '../../../../../../../../../shared/ui/src/components/buttons/buttonChevron';
import {ButtonInheritableProps} from '../../../../../../../../../shared/ui/src/components/buttons/buttonChrome';
import {PopoverTransferProps} from '../../../../../../../../../shared/ui/src/components/popovers/popoverCoordinator';
import {ContactsTableMultiListsChevronDropdown} from './contactsTableMultiListsChevronDropdown';

/*
 * Props.
 */

export interface RenderCardGroupDropdownOptions {
  popoverProps: PopoverTransferProps;
  type: ModifyCardGroupsDropdownTypesEnum;
}

interface ContactsTableMultiListsChevronActionProps {
  buttonProps: ButtonInheritableProps;
  renderCardGroupDropdown: RendererOf<RenderCardGroupDropdownOptions>;
}

/*
 * Component.
 */

export const ContactsTableMultiListsChevronAction: FC<ContactsTableMultiListsChevronActionProps> = (
  props,
) => {
  const {buttonProps, renderCardGroupDropdown} = props;

  return (
    <ButtonChevron
      {...buttonProps}
      renderDropdown={(popoverProps) => (
        <ContactsTableMultiListsChevronDropdown
          popoverProps={popoverProps}
          renderCardGroupDropdown={renderCardGroupDropdown}
        />
      )}
    />
  );
};
